"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function ProducerPage(_a) {
    var user = _a.user, channel = _a.channel, createClip = _a.createClip, deleteEvent = _a.deleteEvent, editEvent = _a.editEvent, eventsInUse = _a.eventsInUse, eventsMatch = _a.eventsMatch, eventsTimeline = _a.eventsTimeline, graphicsUrl = _a.graphicsUrl, isBroadcasting = _a.isBroadcasting, setVideo = _a.setVideo, submitEventForm = _a.submitEventForm, teams = _a.teams, video = _a.video;
    var _b = react_1.useState(false), selectingTimestamp = _b[0], setSelectingTimestamp = _b[1];
    var _c = react_1.useState(0), selectedTimestamp = _c[0], setSelectedTimestamp = _c[1];
    react_1.useEffect(function () {
        // Get initial body background color
        var bodyInitialBackgroundColor = document.querySelector('body')
            .style.backgroundColor;
        // Set body background color on mount
        document.querySelector('body').style.backgroundColor = '#080321';
        return function cleanUp() {
            // Reset initial body background color on unmount
            document.querySelector('body')
                .style.backgroundColor = bodyInitialBackgroundColor;
        };
    }, []);
    function getMaxHeight() {
        var menu = document.querySelector('.storybook-menus-dashboard-header');
        if (!menu) {
            return 'calc(100vh - 80px)';
        }
        var styles = window.getComputedStyle(menu);
        var margin = ['marginTop', 'marginBottom']
            .map(function (key) { return parseFloat(styles[key]); })
            .reduce(function (acc, curr) { return acc + curr; });
        var menuHeight = menu.offsetHeight + margin;
        return "calc(100vh - " + menuHeight + "px)";
    }
    return (react_1.default.createElement(storybook_1.Layouts.ContainerWithSidebar, null,
        react_1.default.createElement("div", { className: 'col-start-1 col-span-4 flex flex-wrap flex-col', style: { maxHeight: getMaxHeight(), minHeight: 600 } },
            react_1.default.createElement(storybook_1.Producer.Player, { channel: channel, user: user, video: video, setVideo: setVideo, selectingTimestamp: selectingTimestamp, onSelectedTimestamp: function (timestamp) {
                    setSelectingTimestamp(false);
                    setSelectedTimestamp(timestamp);
                } }),
            react_1.default.createElement(storybook_1.Producer.EventListInUse, { channel: channel, createClip: function (id, timestamp) { return createClip(id, timestamp); }, deleteEvent: function (id) { return deleteEvent(id); }, editEvent: function (id) { return editEvent(id); }, user: user, items: eventsInUse.map(function (event) {
                    var team_id = event.team_id, rest = __rest(event, ["team_id"]);
                    var team = teams.filter(function (t) { return t.id === parseInt(team_id); })[0];
                    return __assign(__assign({}, (team && team.hasOwnProperty('id') ? { team: team } : {})), rest);
                }) })),
        react_1.default.createElement("div", { className: 'col-span-4 flex flex-wrap flex-col', style: { maxHeight: getMaxHeight(), minHeight: 600 } },
            react_1.default.createElement(storybook_1.Producer.Graphics, { url: graphicsUrl }),
            react_1.default.createElement(storybook_1.Producer.EventForm, { channel: channel, eventsMatch: eventsMatch, eventsTimeline: eventsTimeline, isBroadcasting: isBroadcasting, teams: teams, onSelectEvent: function (_a) {
                    var selectedEvent = _a.selectedEvent;
                    if (selectedEvent.hasOwnProperty('event_template_id')) {
                        setSelectingTimestamp(true);
                    }
                }, submitForm: function (data) {
                    // Pass timestamp from the player component
                    data.timestamp = Math.floor(selectedTimestamp);
                    setSelectedTimestamp(0);
                    // Return promise!
                    return submitEventForm(data);
                }, user: user }))));
}
exports.default = ProducerPage;
ProducerPage.propTypes = {
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        label: prop_types_1.default.string.isRequired,
    }).isRequired,
    createClip: prop_types_1.default.func,
    deleteEvent: prop_types_1.default.func,
    editEvent: prop_types_1.default.func,
    eventsInUse: prop_types_1.default.array,
    eventsMatch: prop_types_1.default.array,
    eventsTimeline: prop_types_1.default.array,
    graphicsUrl: prop_types_1.default.string,
    submitEventForm: prop_types_1.default.func,
};
ProducerPage.defaultProps = {
    createClip: function () {
    },
    deleteEvent: function () {
    },
    editEvent: function () {
    },
    eventsInUse: [],
    eventsMatch: [],
    eventsTimeline: [],
    graphicsUrl: '',
    submitEventForm: function () { return new Promise(function (resolve, reject) { return resolve(); }); }, // Should return a promise in order to clear form on successful submission
};
